import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

interface CodeBlockProps {
  code: string;
  language?: string;
  description?: string;
}

export const CodeBlock = ({
  code,
  language = 'ruby',
  description,
}: CodeBlockProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  return (
    <div className="mt-4 w-full">
      {description && (
        <div className="mb-2 text-sm text-gray-600 dark:text-gray-400">
          {description}
        </div>
      )}
      <div className="relative w-full overflow-hidden rounded-lg border border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-900">
        <div className="flex items-center justify-between border-b border-gray-200 bg-gray-100 px-4 py-2 dark:border-gray-700 dark:bg-gray-800">
          <div className="flex items-center gap-2">
            <span className="rounded bg-gray-200 px-2 py-1 text-xs font-medium uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-300">
              {language}
            </span>
          </div>
          <button
            onClick={handleCopy}
            className="flex items-center gap-1.5 rounded px-2 py-1 text-sm text-gray-600 transition-colors hover:bg-gray-200 dark:text-gray-400 dark:hover:bg-gray-700"
            title={copied ? 'Copied!' : 'Copy to clipboard'}>
            {copied ? (
              <>
                <Check className="h-4 w-4" />
                <span>Copied!</span>
              </>
            ) : (
              <>
                <Copy className="h-4 w-4" />
                <span>Copy</span>
              </>
            )}
          </button>
        </div>

        <div className="max-h-[60vh] overflow-auto">
          <pre className="p-4">
            <code className="text-sm font-mono text-gray-900 dark:text-gray-100">
              {code}
            </code>
          </pre>
        </div>
      </div>
    </div>
  );
};
